import { currentTab } from '../state'

/**
 * Update the current tab based on route query
 * @param {Object} route - Vue Router route object
 * @param {string} defaultTab - Default tab to show if none is specified
 */
export const updateCurrentTab = (route, defaultTab = 'posts') => {
  // Safely update tab with validation
  const tabFromRoute = route.query.tab
  
  // Update current tab with route value or default
  if (tabFromRoute) {
    currentTab.value = tabFromRoute
  } else {
    currentTab.value = defaultTab
  }
}
